import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { RelationshipType } from "Globals/Models/RelationshipType";

export class RelationshipTypeStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private relationshipTypes: RelationshipType[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.relationshipTypes = initialState.relationshipTypes;
    }

    @MobX.action
    public getRelationshipTypeName(relationshipTypeId: string | null): string {
        if (relationshipTypeId == null) return "";
        if (relationshipTypeId == "0") return "Error";
        let relation = this.getSortedByOrdinal.find((relation) => relationshipTypeId === relation.id);
        return relation ? relation.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): RelationshipType[] {
        return this.relationshipTypes.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getRelationshipTypeOptions(): KeyValuePair[] {
        let options = this.getSortedByOrdinal.map((relation) => ({ value: relation.id, key: relation.name })) as KeyValuePair[];

        return options;
    }
}
